/**
 * Scenario assembly — one per depth (doc 09's descent ladder).
 *
 * A scenario is map + shoal pools + starting kit, and nothing else: the sim
 * cannot tell an authored pool from a generated one (doc 14), and it cannot
 * tell THE SHELF from THE GLOOM except by the data it was handed.
 */

import buildings from '../content/buildings.json' with { type: 'json' };
import mapD1 from '../content/map-d1.json' with { type: 'json' };
import mapD2 from '../content/map-d2.json' with { type: 'json' };
import mapD3 from '../content/map-d3.json' with { type: 'json' };
import shoalsD1 from '../content/shoals-d1.json' with { type: 'json' };
import shoalsD2 from '../content/shoals-d2.json' with { type: 'json' };
import shoalsD3 from '../content/shoals-d3.json' with { type: 'json' };
import type { MapDef, Scenario } from './types.ts';

interface DepthContent {
  map: MapDef;
  shoals: { depth: number; act1: Scenario['shoals']; act2: Scenario['act2Shoals'] };
}

/** Every depth that exists, in descent order. */
const CONTENT: Record<number, DepthContent> = {
  1: { map: mapD1 as MapDef, shoals: shoalsD1 as unknown as DepthContent['shoals'] },
  2: { map: mapD2 as MapDef, shoals: shoalsD2 as unknown as DepthContent['shoals'] },
  3: { map: mapD3 as MapDef, shoals: shoalsD3 as unknown as DepthContent['shoals'] },
};

export const DEPTHS_BUILT: number[] = Object.keys(CONTENT).map(Number).sort((a, b) => a - b);

/** The scenario for one depth. Throws on a depth that has not been built yet. */
export function scenarioFor(depth: number): Scenario {
  const c = CONTENT[depth];
  if (!c) throw new Error(`no content for depth ${depth}`);
  return {
    map: c.map,
    depth: c.shoals.depth,
    shoals: c.shoals.act1,
    act2Shoals: c.shoals.act2,
    startingKit: { ...buildings.startingKit },
  };
}

/** D1, by its old name — the harness and the golden replays are built on it. */
export function skeletonScenario(): Scenario {
  return scenarioFor(1);
}
